import port_names from "../data/ports.json";

export const port_name = (port_code) => {
  return port_names[port_code];
};
